import React from "react";
import { useNavigate } from "react-router-dom";
import { createBlog } from "adminApi/BlogApi/Blog";
import { getBlogCategoryDropdown } from "adminApi/BlogApi/BlogCategory";
import { getBlogTagDropdown } from "adminApi/BlogApi/BlogTag";
import { BlogRules } from "validation/ValidationRules";
import { validateForm } from "utils/validation";
import Spinner from "Common/Globle/Spinner";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";
import fields from "../../json/BlogFields.json";
import BlogForm from "./Components/BlogForm";

const AddBlog = () => {
    const navigate = useNavigate();
    const { formdata } = fields;

    const initialValues = formdata.reduce((acc, field) => ({
        ...acc,
        [field.name]: field.name === "tag_ids" ? [] : "",
    }), {});

    const { values, errors, handleChange, handleFileChange, setErrors } = useFormChange(initialValues, BlogRules);

    // Dropdown data fetched in parent — not inside the form component
    const { data: categoryOptions, loading: loadingCategories } = useFetchAllData(getBlogCategoryDropdown);
    const { data: tagOptions, loading: loadingTags } = useFetchAllData(getBlogTagDropdown);

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            const formData = new FormData();
            Object.entries(formValues).forEach(([key, val]) => {
                if (key === "tag_ids") {
                    formData.append(key, JSON.stringify(val));
                } else if (val !== null && val !== undefined) {
                    formData.append(key, val);
                }
            });
            return await createBlog({ data: formData });
        },
        (vals) => {
            const err = validateForm(vals, BlogRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Blog created successfully"
    );

    return (
        <>
            {(loadingSubmit || loadingCategories || loadingTags) && <Spinner isSpinner={true} />}
            <BlogForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleFileChange={handleFileChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                categoryOptions={categoryOptions || []}
                tagOptions={tagOptions || []}
                title="Add Blog"
                submitLabel="Create Blog"
            />
        </>
    );
};

export default AddBlog;
